import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default () => {
  gsap.registerPlugin(ScrollTrigger);

  let menu = document.querySelector('.menu-video');
  let burger = document.querySelector('.burger');
  let body = document.body;
  let logo = document.querySelector('.logo');

  burgerColorToggle();

  if (burger && menu) {
    burger.addEventListener('click', (e) => {
      e.preventDefault();
    
      setMenuState(-1);
    });
  }

  function setMenuState(isOpen) {
    // 1 - open
    // 0 - close
    // -1 toggle

    if (isOpen === -1) {
      if(body.classList.toggle('is-menu-opened')) {
        animateMenu();
      }
      menu.classList.toggle('menu--opened');
      logo.classList.toggle('logo-menu-opened');
      burger.classList.toggle('burger--crossed');
      
    } else if (!!isOpen) {
      body.classList.add('is-menu-opened');
      menu.classList.add('menu--opened');
      logo.classList.add('logo-menu-opened');
      burger.classList.add('burger--crossed');

      animateMenu();

    } else {
      body.classList.remove('is-menu-opened');
      menu.classList.remove('menu--opened');
      burger.classList.remove('burger--crossed');
      logo.classList.remove('logo-menu-opened');
    }
  }
  function burgerColorToggle() {
    let leaveBlack = document.querySelector('.burger-dark-leave');
    let forceWhiteEls = document.querySelectorAll('.burger-white');

    let st = ScrollTrigger.create({
      trigger: leaveBlack,
      start: "top top",
      end: "+=100%",
      onLeave: self => burger.classList.add('burger--black'),
      onEnterBack: self => burger.classList.remove('burger--black'),
    });

    if (forceWhiteEls.length) {
      forceWhiteEls.forEach(function(white) {
        let st = ScrollTrigger.create({
          trigger: white,
          start: "top top",
          end: "bottom top",
          onEnter: self => burger.classList.add('burger--white'),
          onEnterBack: self => burger.classList.add('burger--white'),
          onLeave: self => burger.classList.remove('burger--white'),
          onLeaveBack: self => burger.classList.remove('burger--white'),
          onUpdate: self => {
            //console.log("progress:", self.progress.toFixed(3), "direction:", self.direction, "velocity", self.getVelocity());
          }
        });
      });
    }
  }

  function animateMenu() {
    let menuItems = document.querySelectorAll('.menu__item');

    gsap.fromTo(menuItems,
      {
        y: 40,
        opacity: 0
      },
      {
        y: 0,
        opacity: 1,
        stagger: 0.09,
        delay: 0.4,
        duration: 0.65
      }
    );
  }
}

